import { createFileRoute } from '@tanstack/react-router'
import * as React from 'react'
import { OutcomeFormScreen } from '../features/visit-outcome/outcome-form'
import { readTechToken, TechLinkOutcomeScreen } from '../features/visit-outcome/tech-link-form'

/**
 * Staff can still use the signed-in #763 screen. A #983 fragment bearer opens only the public, one-visit projection;
 * the root guard recognizes that exact fragment and never creates a staff or contractor session.
 */
export const Route = createFileRoute('/visit-outcome/$visitId')({
  component: function VisitOutcomeRoute() {
    const { visitId } = Route.useParams()
    const [hasTechToken] = React.useState(() => typeof window !== 'undefined' && readTechToken(window.location) !== null)
    if (hasTechToken) return <TechLinkOutcomeScreen visitId={visitId} />
    return <OutcomeFormScreen visitId={visitId} />
  },
})
